// Module
var code = "<div class=\"form-group schema-form-{{form.type}} {{form.htmlClass}}\"> <div class=\"ecv-label\"> <div class=\"form-control {{form.fieldHtmlClass}}\"> <span ng-bind-html=\"form.labelText | trustText\">{{ form.labelText }}</span> </div> </div> <div class=\"help-block\" sf-message=\"form.description\"></div> </div> ";
// Exports
var _module_exports = code;;
var path = 'app/common/schemaFormUtility/components/addons/templates/ecv-label.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;